<template>
	<div class="col-12 pl-0 pr-0">
		<GChart
		type="ColumnChart"
		:data="chartData"
		:options="chartOptions"
		:resizeDebounce="500"
		/>
	</div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
	components: {
		GChart
	},
	name: 'IChart',
	data() {
		return {
			// chartData: [
			// ['Month', 'Produk 1', 'produk 2', 'produk 3],
			// ['Jan', 1000, 400, 300],
			// ['Feb', 1170, 460], 200,
			// ['Mar', 660, 1120],
			// ['Apr', 1030, 350],
			// ['Mei', 1030, 540],
			// ['Jun', 1030, 350],
			// ['Jul', 1030, 540],
			// ['Agu', 1030, 350],
			// ['Sep', 1030, 540],
			// ['Okt', 1030, 350],
			// ['Nov', 1030, 540],
			// ['Des', 1030, 350],
			// ],
			chartOptions: {
				legend: {
					position: 'bottom',
					alignment: 'start'
				},
				chart: {
				},
				chartArea:{
					left:30,
					top:30,
					width:'100%'
					,height:'66%'
				},
				animation:{
					duration: 2000,
					easing: 'out',
					startup: 'true',
				},
				fontName: 'Poppins',
				fontSize: 11,
				width: '100%',
				height: 250,
				colors: ['B831D2', '#7f7f7f', '#5d22ac']

			},
		}
	},
	props:{
		chartData:{
			type:Array
		}
	},
	methods: {
		createCustomHTMLContent(flagURL, totalGold, totalSilver, totalBronze) {
			return '<div style="padding:5px 5px 5px 5px;">' +
			'<img src="' + flagURL + '" style="width:75px;height:50px"><br/>' +
			'<table class="medals_layout">' + '<tr>' +
			'<td><img src="https://upload.wikimedia.org/wikipedia/commons/1/15/Gold_medal.svg" style="width:25px;height:25px"/></td>' +
			'<td><b>' + totalGold + '</b></td>' + '</tr>' + '<tr>' +
			'<td><img src="https://upload.wikimedia.org/wikipedia/commons/0/03/Silver_medal.svg" style="width:25px;height:25px"/></td>' +
			'<td><b>' + totalSilver + '</b></td>' + '</tr>' + '<tr>' +
			'<td><img src="https://upload.wikimedia.org/wikipedia/commons/5/52/Bronze_medal.svg" style="width:25px;height:25px"/></td>' +
			'<td><b>' + totalBronze + '</b></td>' + '</tr>' + '</table>' + '</div>';
		}
	}
};
</script>